import api from './api'

const documentServices = {
    create(data){
        return api().post('documents', data)
    },
    index(sort){
        return api().get(`documents${sort ? sort : ''}`)
    },
    document(id){
        return api().get(`documents/${id}`)
    },
    delete(id){
        return api().delete(`documents/${id}`)
    }
}

export default documentServices
